import { useMutation, useQueryClient } from "@tanstack/react-query";
import { requestURLs } from "../../Environment";
import {
  AxiosResponseAndError,
  ResponseType,
} from "@/api/types/axiosResponseType";
import ApiRequest from "../ApiRequest";
import { QUERY_KEYS } from "../query/querykeys";

type ProjectRemoveResponseType = ResponseType<null>;

function useRemoveProjectMutation() {
  const queryClient = useQueryClient();
  const mutation = useMutation<
    AxiosResponseAndError<ProjectRemoveResponseType>["response"],
    AxiosResponseAndError<ProjectRemoveResponseType>["error"],
    string
  >({
    mutationFn: (data) =>
      ApiRequest.delete<ProjectRemoveResponseType>(
        `${requestURLs.project}/${data}`,
      ),
    onSuccess: async () => {
      await Promise.all([
        queryClient.invalidateQueries({
          queryKey: [QUERY_KEYS.getProjects],
        }),
        queryClient.invalidateQueries({
          queryKey: [QUERY_KEYS.getProjectsNocal],
        }),
        queryClient.invalidateQueries({
          queryKey: [QUERY_KEYS.portfolioDashboard],
        }),
      ]);
    },
  });

  return mutation;
}

export default useRemoveProjectMutation;
